import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../redux/authSlice';
import axiosInstance from '../api/axiosConfig.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './Login.css';
import logo from '../assets/img.png';
import {jwtDecode} from "jwt-decode"; // Zorg ervoor dat het pad naar het logo correct is

const Login = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axiosInstance.post('/login', { userName, password });
            const token = response.data.token;
            dispatch(login({ token }));
            sessionStorage.setItem('authToken', token);

            const decoded = jwtDecode(token);

            let hasClockSystemAccess = false;

            if (decoded.roles && Array.isArray(decoded.roles)) {
                hasClockSystemAccess = decoded.roles.includes('KLOKSYSTEEM');
            } else if (decoded.role) {
                hasClockSystemAccess = decoded.role === 'KLOKSYSTEEM';
            }

            if (hasClockSystemAccess) {
                navigate('/clockin');
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            setError('Login mislukt. Controleer je gegevens en probeer opnieuw.');
            console.error(error);
        }
    };

    return (
        <div className="container-fluid vh-100 vw-100 d-flex flex-column">
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="card shadow-lg p-4 position-relative" style={{ maxWidth: '400px', width: '100%', borderRadius: '10px' }}>
                    {/* Voeg hier het logo toe */}
                    <div className="text-center mb-4" style={{ position: 'relative', zIndex: 1 }}>
                        <img src={logo} alt="HorecaMasters Logo" style={{ maxWidth: '250px', height: '130px'}} />
                    </div>
                    {/* Verplaats de h2 iets naar boven en verminder de ruimte */}
                    <h2 className="text-center mb-2" style={{ fontSize: '1.5rem', color: 'black', position: 'relative', top: '-30px', zIndex: 2 }}>
                        Inloggen
                    </h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="fas fa-user" style={{ color: 'black' }}></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="userName"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    placeholder="Voer je gebruikersnaam in"
                                    required
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="fas fa-lock" style={{ color: 'black' }}></i>
                                </span>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Voer je wachtwoord in"
                                    required
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3" style={{ fontSize: '14px' }}>
                            <div className="form-check" style={{ marginBottom: 0 }}>
                                <input
                                    type="checkbox"
                                    id="rememberMe"
                                    className="form-check-input"
                                    checked={rememberMe}
                                    onChange={() => setRememberMe(!rememberMe)}
                                    style={{ transform: 'scale(1.2)' }} // Vergroot de checkbox voor betere zichtbaarheid
                                />
                                <label htmlFor="rememberMe" className="form-check-label">Wachtwoord onthouden</label>
                            </div>
                            <a href="/forgot-password" className="text-primary">Wachtwoord vergeten?</a>
                        </div>
                        {error && <div className="alert alert-danger">{error}</div>}
                        <button type="submit" className="btn btn-primary w-100">Inloggen</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
